module.exports = __webpack_public_path__ + "img/新能源汽车电池壳.a8d94322.jpg";